import type { InstantBonus } from './InstantBonus';

export enum RewardType {
  CasinoFSB = 'Casino Free Spins',
  CasinoInstant = 'Casino Instant Bonus',
  VegasFSB = 'Vegas Free Spins',
  VegasInstant = 'Vegas Instant Bonus'
}

export enum Category {
  SpinOfDay = 'spinOfDay',
  FSB = 'fsb',
  IB = 'ib',
  Rewards = 'rewards'
}

export interface StarsCoinReward {
  name: string;
  id: number;
  type: RewardType;
  price: number;
  description: string;
}

export interface Reward {
  id: number;
  name: string;
  description: string;
  cost: number;
  group: string;
}

export interface RewardData {
  rewards: StarsCoinReward[];
  viplevel: number;
}

export interface InstantBobusData {
  ibs: InstantBonus[];
}

export enum Service {
  All = 'all'
}
